import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSuperAdminAuth } from '../../contexts/SuperAdminAuthContext';
import './SuperAdminLayout.scss';

interface SuperAdminLayoutProps {
  children: React.ReactNode;
}

const SuperAdminLayout: React.FC<SuperAdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useSuperAdminAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/super-admin/login', { replace: true });
  };

  return (
    <div className="super-admin-shell">
      <aside className="super-admin-shell__sidebar">
        <div className="super-admin-shell__brand">
          <div className="super-admin-shell__eyebrow">ZEEDCOM</div>
          <h1>Console</h1>
          <p>Administration globale</p>
        </div>

        <nav className="super-admin-shell__nav">
          <NavLink to="/super-admin/dashboard" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Vue d&apos;ensemble
          </NavLink>
          <NavLink to="/super-admin/stores" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Stores
          </NavLink>
          <NavLink to="/super-admin/templates" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Catalogue modèles
          </NavLink>
          <NavLink to="/super-admin/presets" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Presets
          </NavLink>
          <NavLink to="/super-admin/invitations" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Invitations
          </NavLink>
          <NavLink to="/super-admin/treatments" className={({ isActive }) => `super-admin-shell__link ${isActive ? 'super-admin-shell__link--active' : ''}`}>
            Traitements
          </NavLink>
        </nav>
      </aside>

      <div className="super-admin-shell__content">
        <header className="super-admin-shell__header">
          <div>
            <div className="super-admin-shell__header-label">Portail super-admin</div>
            <div className="super-admin-shell__header-title">
              {user?.first_name} {user?.last_name}
            </div>
          </div>

          <div className="super-admin-shell__header-actions">
            <span className="super-admin-shell__email">{user?.email}</span>
            <button type="button" className="super-admin-shell__logout" onClick={handleLogout}>
              Déconnexion
            </button>
          </div>
        </header>

        <main className="super-admin-shell__main">{children}</main>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
